import React, { useState } from 'react';
import { useNavigate, useLocation } from 'react-router-dom';
import { useAuth } from '@/contexts/AuthContext';
import { useLanguage } from '@/contexts/LanguageContext';
import { Button } from '@/components/ui/button';
import { Input } from '@/components/ui/input';
import { Label } from '@/components/ui/label';
import { toast } from 'sonner';

export const LoginPage = () => {
  const [loginId, setLoginId] = useState('');
  const [password, setPassword] = useState('');
  const [loading, setLoading] = useState(false);
  const { login } = useAuth();
  const { t, language, changeLanguage } = useLanguage();
  const navigate = useNavigate();
  const location = useLocation();

  const handleSubmit = async (e) => {
    e.preventDefault();
    setLoading(true);
    
    const result = await login(loginId, password);
    setLoading(false);
    
    if (result.success) {
      navigate('/', { replace: true });
    } else {
      toast.error(result.error);
    }
  };

  return (
    <div className="min-h-screen flex items-center justify-center" style={{ backgroundColor: '#F8FAFC' }}>
      <div className="w-full max-w-md">
        <div className="bg-white rounded-xl shadow-sm border border-slate-200 p-8">
          <div className="flex justify-between items-center mb-6">
            <h1 className="text-3xl font-bold" style={{ fontFamily: 'Manrope', color: '#1E3A8A' }}>
              OctoBoots
            </h1>
            <button
              data-testid="language-toggle"
              onClick={() => changeLanguage(language === 'en' ? 'zh' : 'en')}
              className="text-sm px-3 py-1 rounded-md border border-slate-300 hover:bg-slate-50"
            >
              {language === 'en' ? '中文' : 'EN'}
            </button>
          </div>
          
          <p className="text-slate-600 mb-8" style={{ fontFamily: 'IBM Plex Sans' }}>
            {t('auth.subtitle')}
          </p>

          <form onSubmit={handleSubmit} className="space-y-6">
            <div>
              <Label htmlFor="loginId" data-testid="login-id-label">
                {t('auth.loginId')}
              </Label>
              <Input
                id="loginId"
                data-testid="login-id-input"
                type="text"
                value={loginId}
                onChange={(e) => setLoginId(e.target.value)}
                required
                className="mt-2"
                placeholder="email@example.com or phone"
              />
            </div>

            <div>
              <Label htmlFor="password" data-testid="password-label">
                {t('auth.password')}
              </Label>
              <Input
                id="password"
                data-testid="password-input"
                type="password"
                value={password}
                onChange={(e) => setPassword(e.target.value)}
                required
                className="mt-2"
              />
            </div>

            <Button
              data-testid="login-submit-btn"
              type="submit"
              disabled={loading}
              className="w-full"
              style={{ backgroundColor: '#1E3A8A' }}
            >
              {loading ? t('common.loading') : t('auth.login')}
            </Button>

            <div className="text-center pt-2">
              <button
                type="button"
                data-testid="forgot-password-link"
                onClick={() => navigate('/forgot-password')}
                className="text-sm text-blue-700 hover:underline"
              >
                {t('auth.forgotPassword')}
              </button>
            </div>
          </form>
        </div>
      </div>
    </div>
  );
};